<span><span class="fa fa-spinner fa-spin"></span><span class="sr-only">Betöltés...</span></span>


// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/shared/components/loading/loading.component.ts.LoadingComponent.html